import { NonIdealState, Spinner } from "@blueprintjs/core";
import { type Tag } from "@package/ui-gql/index-data-access";
import { MediaDisplay } from "@package/ui-wall-components";
import { useFlyoutSearchState } from "../SearchContextProvider/context-flyout-search";

type SearchViewTagsTileProps = {
  tag: Tag;
};

function SearchViewTagsTile({ tag }: SearchViewTagsTileProps) {
  const { backgroundColorPrimary, colorPrimary, large, onSelectTag } =
    useFlyoutSearchState();

  const classNameMedia = large ? "max-h-80" : "max-h-48";

  return (
    <div
      className={`relative mr-8 mb-8 p-4 rounded-2xl ${large ? "w-64 h-64" : "w-48 h-48"}`}
      style={{
        backgroundColor: tag.mediaIcon ? "unset" : backgroundColorPrimary,
      }}
    >
      {!!tag.mediaIcon && (
        <div
          className="absolute flex flex-col justify-center items-center left-0 top-0 w-full h-full"
          onPointerDown={() => onSelectTag(tag)}
        >
          <div className={classNameMedia}>
            <MediaDisplay
              id={tag.mediaIcon}
              classNameMedia={classNameMedia}
              forceFit
            />
          </div>
        </div>
      )}
      {!!tag.icon && (
        <div
          className="absolute left-0 top-0 flex w-full h-full flex-col justify-center items-center overflow-hidden text-center text-ellipsis text-3xl font-bold"
          style={{ color: colorPrimary }}
        >
          {tag.icon}
        </div>
      )}
    </div>
  );
}

export function SearchViewTags() {
  const { error, loading, tags } = useFlyoutSearchState();

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full">
        <NonIdealState
          icon="error"
          title="Error"
          description="Error loading Tags for Search"
        />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full">
        <Spinner size={200} />
      </div>
    );
  }

  return (
    <div className="relative w-full h-full flex flex-wrap justify-center items-center content-center">
      {tags.map((tag) => (
        <SearchViewTagsTile key={tag.id} tag={tag} />
      ))}
    </div>
  );
}
